'use strict'

module.exports = {
  dev: {
    appId: 'wx1d1089c5677cc2d2',
    redirectUri: 'http://127.0.0.1:8080',
    requestUri: 'http://localhost:8010'
  },

  build: {
    appId: 'wxcaa9d2865cd34eca',
    redirectUri: 'http://weixin.kadz.com.cn'
  },

  buildtest: {
    appId: 'wx094917673db59edb',
    redirectUri: 'http://weixin.keaomds.cn'
  }
}



// WEBPACK FOOTER //
// ./src/wechat.js